import { render, staticRenderFns } from "./EntitlementTable.vue?vue&type=template&id=7fb1faac"
import script from "./EntitlementTable.vue?vue&type=script&lang=js"
export * from "./EntitlementTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports